import MDTypography from "components/MDTypography";

import { useCallback, useContext } from "react";
import MDButton from "components/MDButton";
import useModalState from "hooks/useModalState";
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import Modal from "modules/Modal/Modal";
import ProjectFileExplorer from "modules/ProjectFiles/ProjectFileExplorer";
import MDBox from "components/MDBox";
import useUpdateProposalProductProjectFiles from "hooks/proposals/useUpdateProposalProductProjectFiles";
import ProposalContext from "./providers/ProposalContextProvider";

export default function AddProjectFileToProposal({ id }: { id: string }) {
  const { proposal } = useContext(ProposalContext);
  const {
    open: projectFilesModalOpen,
    onClose: onCloseProjectFilesModal,
    onOpen: onOpenProjectFilesModal,
  } = useModalState();

  const [updateProposalProductProjectFiles] = useUpdateProposalProductProjectFiles();

  const handleProjectFiles = useCallback(
    (projectFileId: string | Array<string>) => {
      updateProposalProductProjectFiles({
        variables: {
          projectFileIds: Array.isArray(projectFileId) ? projectFileId : [projectFileId],
          proposalProductId: id,
        },
      });
    },
    [id, updateProposalProductProjectFiles]
  );

  const handleProjectFilesFolderSelect = useCallback(
    (fileId: string | Array<string>) => {
      handleProjectFiles(fileId);
      onCloseProjectFilesModal();
    },
    [handleProjectFiles, onCloseProjectFilesModal]
  );

  return (
    <MDBox>
      <MDButton
        type="button"
        color="blue"
        onClick={() => {
          onOpenProjectFilesModal();
        }}
      >
        <AddCircleOutlineOutlined />{" "}
        <MDTypography variant="body2" ml={2} color="#FFF">
          Add file from project files
        </MDTypography>
      </MDButton>
      <Modal
        open={projectFilesModalOpen}
        onClose={onCloseProjectFilesModal}
        styles={{ overflow: "hidden" }}
      >
        <MDBox px={3} pt={3}>
          <MDTypography variant="h6">Project Files</MDTypography>
        </MDBox>
        <MDBox px={3} pb={3} sx={{ height: "calc(100% - 56px)" }}>
          <ProjectFileExplorer
            enableSelectFile={true}
            hideAddFile={false}
            allowMultiSelect={true}
            mode="file-attach"
            initialSelectedItems={proposal?.projectFilesFolderId || null}
            height="100%"
            submitFn={(lastSelectedItem) => {
              handleProjectFilesFolderSelect(lastSelectedItem);
              onCloseProjectFilesModal();
            }}
          />
        </MDBox>
      </Modal>
    </MDBox>
  );
}
